import React from 'react';
import { PropTypes } from 'prop-types';
import { get } from 'lodash';
import formatDate from 'common/utils/Dates/formatDate';
import BaseTimelineEvent from 'common/Workqueue/BaseTimelineEvent';
import { getTimelineEventDetails } from 'common/Workqueue/timelineEventUtils';
import { ENROLLMENT_STATUSES } from '../constants';
import {
  buildTimelineEventDetailItems,
  getStatusLabel,
  STATUS_TO_ICON,
} from './enrollmentTimelineEventUtils';

const EnrollmentStatusEvent = ({ timelineEvent }) => {
  const additionalData = get(timelineEvent, 'additional_data', {});
  const eventChanges = get(timelineEvent, 'changes', []);
  const employeeName = get(additionalData, 'employee_name', 'System');
  const statusText = eventChanges.find((change) => change.field_name === 'enrollment_status')?.to;
  const date = formatDate(timelineEvent.timestamp);

  let messagePrefix = getStatusLabel(statusText);
  if (statusText === ENROLLMENT_STATUSES.inReview) {
    messagePrefix = 'Placed In Review';
  } else if (statusText === ENROLLMENT_STATUSES.open) {
    messagePrefix = 'Moved to Open';
  }

  const eventDetailItems = buildTimelineEventDetailItems(timelineEvent, false);
  const eventDetails = getTimelineEventDetails(eventDetailItems, date);

  return (
    <BaseTimelineEvent
      icon={STATUS_TO_ICON[statusText] || 'IconPencil'}
      message={`${messagePrefix} by ${employeeName}`}
      date={date}
      eventDetails={eventDetails}
    />
  );
};

EnrollmentStatusEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default EnrollmentStatusEvent;
